// extracted by mini-css-extract-plugin
module.exports =  {"base-badge":"Yv8K0OF","baseBadge":"Yv8K0OF","content":"uzZIC3q"};